// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1TKNp","calendarButtons":"ClockData_calendarButtons__2XyNH"};